/**
 * How many site filters are applied, for the count badge on the filter
 * button. Search is left out: it has its own visible field. Sort order is
 * not a filter.
 */
export function countActiveSiteFilters(query: {
    nearMe?: unknown;
    siteTypeFilters?: unknown;
    amenitiesFilters?: unknown;
    datesFilters?: unknown;
}): number {
    const list = (value: unknown) => (Array.isArray(value) ? value.length : typeof value === 'string' && value ? 1 : 0);
    const nearMe = query.nearMe === true || query.nearMe === 'true' ? 1 : 0;
    // 'all' ("Both days") still narrows the list to sites open both days.
    const dates = typeof query.datesFilters === 'string' && query.datesFilters ? 1 : 0;
    return nearMe + list(query.siteTypeFilters) + list(query.amenitiesFilters) + dates;
}
